function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import defaultPropTypes from "../utils/prop-types";
import OticonLocationDetailForm from "./location-detail-form";
import { getAll } from "../../../../../../../wdh-foundation/wdh";
import { trackHCLClinicDriving, trackHCLClinicEmail, trackHCLClinicPhone, trackHCLClinicWWW } from "../../../../../js/project/tracking-gtm-ga4";
var OticonLocationDetail = /*#__PURE__*/function (_React$Component) {
  function OticonLocationDetail(props) {
    var _this;
    _classCallCheck(this, OticonLocationDetail);
    _this = _callSuper(this, OticonLocationDetail, [props]);
    _this.state = {
      formDidSubmit: false,
      formSubmitError: false
    };
    _this.handleFormSubmitSuccess = _this.handleFormSubmitSuccess.bind(_this);
    _this.handleFormSubmitError = _this.handleFormSubmitError.bind(_this);
    _this.handleFormWillSubmit = _this.handleFormWillSubmit.bind(_this);
    _this.renderExternalComponents = _this.renderExternalComponents.bind(_this);
    _this.findLocationWithId = _this.findLocationWithId.bind(_this);
    return _this;
  }
  _inherits(OticonLocationDetail, _React$Component);
  return _createClass(OticonLocationDetail, [{
    key: "handleFormSubmitSuccess",
    value: function handleFormSubmitSuccess() {
      this.setState({
        formDidSubmit: true
      });
    }
  }, {
    key: "handleFormSubmitError",
    value: function handleFormSubmitError() {
      this.setState({
        formSubmitError: true
      });
    }
  }, {
    key: "handleFormWillSubmit",
    value: function handleFormWillSubmit() {
      this.setState({
        formSubmitError: false
      });
    }
  }, {
    key: "findLocationWithId",
    value: function findLocationWithId(id) {
      var location = this.props.locations.find(function (loc) {
        return loc.UniqueId.toString() === id.toString();
      });
      return location;
    }
  }, {
    key: "renderComponentWithSelector",
    value: function renderComponentWithSelector(selector, key) {
      var _component$classList;
      var component = document.querySelector(selector);
      return /*#__PURE__*/React.createElement(React.Fragment, null, component && /*#__PURE__*/React.createElement("div", {
        key: key || selector.substring(1),
        className: component === null || component === void 0 || (_component$classList = component.classList) === null || _component$classList === void 0 ? void 0 : _component$classList.toString(),
        dangerouslySetInnerHTML: {
          __html: component.innerHTML
        }
      }));
    }
  }, {
    key: "renderExternalComponents",
    value: function renderExternalComponents() {
      var components = getAll(this.props.externalComponentSelector);
      return /*#__PURE__*/React.createElement(React.Fragment, null, components === null || components === void 0 ? void 0 : components.map(function (component, index) {
        var _component$classList2;
        return /*#__PURE__*/React.createElement("div", {
          // eslint-disable-next-line react/no-array-index-key
          key: "external-component-".concat(index),
          className: component === null || component === void 0 || (_component$classList2 = component.classList) === null || _component$classList2 === void 0 ? void 0 : _component$classList2.toString(),
          dangerouslySetInnerHTML: {
            __html: component.innerHTML
          }
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var location = this.findLocationWithId(this.props.match.params.id);
      return /*#__PURE__*/React.createElement("div", {
        className: "location-detail"
      }, location && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, location.Name)), /*#__PURE__*/React.createElement("button", {
        className: "close-button",
        "aria-label": "Close",
        onClick: function onClick(e) {
          _this2.props.onCloseLocation(e);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("strong", null, location.Name)), /*#__PURE__*/React.createElement("div", {
        className: "info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "info-left-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "address"
      }, location.Address), /*#__PURE__*/React.createElement("div", {
        className: "address"
      }, location.PostalCode, " ", location.City)), /*#__PURE__*/React.createElement("div", {
        className: "info-right-col"
      }, !!location.Phone && /*#__PURE__*/React.createElement("div", {
        className: "phone"
      }, "".concat(this.props.settings.dictionary.phone, ": "), /*#__PURE__*/React.createElement("a", {
        href: "tel:".concat(location.Phone),
        onClick: function onClick() {
          window.DGS.Event.getInstance().trigger("trackLocationsPhoneNumber", location.Name, location.PostalCode);
          trackHCLClinicPhone("".concat(location.Name, " - ").concat(location.PostalCode), location.UniqueId);
        },
        title: location.Phone
      }, location.Phone)), !!location.Homepage && /*#__PURE__*/React.createElement("div", {
        className: "website"
      }, /*#__PURE__*/React.createElement("a", {
        href: location.Homepage,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: function onClick() {
          window.DGS.Event.getInstance().trigger("trackLocationsWebsiteLink", location.Name, location.PostalCode);
          trackHCLClinicWWW("".concat(location.Name, " - ").concat(location.PostalCode), location.UniqueId);
        },
        title: location.Homepage
      }, location.Homepage.replace("https://", "").replace("http://", ""))), !this.props.settings.Form && !!location.Email && /*#__PURE__*/React.createElement("div", {
        className: "email"
      }, /*#__PURE__*/React.createElement("a", {
        href: "mailto:".concat(location.Email),
        onClick: function onClick() {
          window.DGS.Event.getInstance().trigger("trackLocationsEmailLink", location.Name, location.PostalCode);
          trackHCLClinicEmail("".concat(location.Name, " - ").concat(location.PostalCode), location.UniqueId);
        },
        title: location.Email
      }, location.Email)), /*#__PURE__*/React.createElement("div", {
        className: "distance"
      }, /*#__PURE__*/React.createElement("i", null, "".concat(this.props.distance, " ").concat(this.props.settings.Unit, " ").concat(this.props.userLocation.Name.length ? this.props.settings.dictionary.fromSearchedLocation + " " + this.props.userLocation.Name : this.props.settings.dictionary.fromYourLocation))), /*#__PURE__*/React.createElement("div", {
        className: "directions"
      }, /*#__PURE__*/React.createElement("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        href: "https://www.google.com/maps?daddr=".concat(location.lat, ",").concat(location.lng),
        title: "Google Maps",
        onClick: function onClick() {
          window.DGS.Event.getInstance().trigger("trackLocationsGetDirections", location.Name, location.PostalCode);
          trackHCLClinicDriving("".concat(location.Name, " - ").concat(location.PostalCode), location.UniqueId);
        }
      }, this.props.settings.dictionary.getDirections)))), this.props.settings.Form && !this.state.formDidSubmit && /*#__PURE__*/React.createElement(OticonLocationDetailForm, _extends({}, this.props.settings.Form, {
        configurationId: this.props.settings.Id,
        onFormSubmitSuccess: this.handleFormSubmitSuccess,
        onFormSubmitError: this.handleFormSubmitError,
        onFormWillSubmit: this.handleFormWillSubmit,
        clinicShortName: location.contactDetailsToString(["Name"]),
        clinicName: (location === null || location === void 0 ? void 0 : location.Name) || "-",
        clinicAddress: (location === null || location === void 0 ? void 0 : location.Address) || "-",
        clinicEmail: location.Email || "-",
        clinicPhone: location.Phone || "-",
        clinicCityAndPostCode: (location === null || location === void 0 ? void 0 : location.City) + (location === null || location === void 0 ? void 0 : location.PostalCode) || "-",
        clinicCity: (location === null || location === void 0 ? void 0 : location.City) || "",
        clinicDetails: location.contactDetailsToString(["Name", "Address", "PostalCode", "City", "Country", "Phone", "Email"])
      })), this.state.formDidSubmit && /*#__PURE__*/React.createElement("div", {
        className: "location-details__form-submit-success-wrapper"
      }, this.renderComponentWithSelector(this.props.formSubmitSuccessComponentSelector)), this.state.formSubmitError && /*#__PURE__*/React.createElement("div", {
        className: "location-details__form-submit-error-wrapper"
      }, this.renderComponentWithSelector(this.props.formSubmitErrorComponentSelector)), /*#__PURE__*/React.createElement("div", {
        className: "external-components"
      }, this.renderExternalComponents())));
    }
  }]);
}(React.Component);
OticonLocationDetail.propTypes = {
  onCloseLocation: defaultPropTypes.func,
  settings: defaultPropTypes.settings.isRequired,
  locations: defaultPropTypes.locations.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object.isRequired,
  externalComponentSelector: defaultPropTypes.string,
  formSubmitSuccessComponentSelector: defaultPropTypes.string,
  formSubmitErrorComponentSelector: defaultPropTypes.string
};
OticonLocationDetail.defaultProps = {
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation,
  externalComponentSelector: ":not(.external-components) > .location-external-component",
  formSubmitSuccessComponentSelector: ":not(.location-details__form-submit-success-wrapper) > .location-form-submit-success",
  formSubmitErrorComponentSelector: ":not(.location-details__form-submit-error-wrapper) > .location-form-submit-error"
};
export default withRouter(OticonLocationDetail);